<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Actualizar Especialista
  </h2>
  <div class="flex justify-between items-center mb-4">
    <button
      type="button"
      class="bg-blue-500 text-white font-semibold px-4 py-2 rounded-lg shadow hover:bg-blue-600"
      (click)="volver()"
    >
      Volver
    </button>
  </div>
  <form [formGroup]="especialistaForm" (ngSubmit)="actualizarEspecialista()">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <!-- Campo: Nombres -->
      <div>
        <label for="nombres" class="block font-semibold mb-1">Nombres</label>
        <input
          type="text"
          id="nombres"
          formControlName="nombres"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('nombres')?.invalid &&
            especialistaForm.get('nombres')?.touched
          "
        />
        <div
          *ngIf="
            especialistaForm.get('nombres')?.invalid &&
            especialistaForm.get('nombres')?.touched
          "
          class="text-red-500 text-sm"
        >
          Este campo es obligatorio y no puede superar los 100 caracteres.
        </div>
      </div>

      <!-- Campo: Apellidos -->
      <div>
        <label for="apellidos" class="block font-semibold"
          >Apellidos</label
        >
        <input
          type="text"
          id="apellidos"
          formControlName="apellidos"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('apellidos')?.invalid &&
            especialistaForm.get('apellidos')?.touched
          "
        />
        <div
          *ngIf="
            especialistaForm.get('apellidos')?.invalid &&
            especialistaForm.get('apellidos')?.touched
          "
          class="text-red-500 text-sm"
        >
          Este campo es obligatorio y no puede superar los 100 caracteres.
        </div>
      </div>

      <!-- Campo: Correo -->
      <div>
        <label for="correo" class="block font-semibold">Correo</label>
        <input
          type="email"
          id="correo"
          formControlName="correo"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('correo')?.invalid &&
            especialistaForm.get('correo')?.touched
          "
        />
        <div
          *ngIf="
            especialistaForm.get('correo')?.invalid &&
            especialistaForm.get('correo')?.touched
          "
          class="text-red-500 text-sm"
        >
          Ingrese un correo electrónico válido.
        </div>
      </div>

      <!-- Campo: Codigo de Documento -->
      <div>
        <label for="codigo_documento" class="block font-semibold"
          >Codigo de Documento</label
        >
        <input
          type="text"
          id="codigo_documento"
          formControlName="codigo_documento"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('codigo_documento')?.invalid &&
            especialistaForm.get('codigo_documento')?.touched
          "
        />
        <div
          *ngIf="
            especialistaForm.get('codigo_documento')?.invalid &&
            especialistaForm.get('codigo_documento')?.touched
          "
          class="text-red-500 text-sm"
        >
          Ingrese un Codigo de Documento válido
        </div>
      </div>

      <div>
        <label for="clave" class="block font-semibold mb-1">Clave</label>
        <div class="relative">
          <input
            id="clave"
            [type]="showPassword ? 'text' : 'password'"
            formControlName="clave"
            class="border border-gray-300 rounded w-full py-2 px-4 pr-10"
            placeholder="Ingresar clave nueva"
          />
          <button
            type="button"
            class="absolute inset-y-0 right-0 px-3 py-2"
            (click)="togglePasswordVisibility()"
          >
            <i [class]="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
          </button>
        </div>
        <small class="text-red-400"
          >* Solo use este campo si quiere cambiar la clave a uno nuevo</small
        >
      </div>

      <!-- Campo: Unidad Funcional -->
      <div *ngIf="showUnidadFuncional">
        <label for="id_unidad_funcional" class="block text font-semibold">
          Unidad Funcional
        </label>
        <select
          id="id_unidad_funcional"
          formControlName="id_unidad_funcional"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('id_unidad_funcional')?.invalid &&
            especialistaForm.get('id_unidad_funcional')?.touched
          "
        >
          <option [value]="null" disabled selected hidden>
            Seleccione una unidad funcional
          </option>
          <option
            *ngFor="let uf of unidadesFuncionales"
            [value]="uf.id_unidad_funcional"
          >
            {{ uf.nombre }}
          </option>
        </select>
        <div
          *ngIf="
            especialistaForm.get('id_unidad_funcional')?.invalid &&
            especialistaForm.get('id_unidad_funcional')?.touched
          "
          class="text-red-500 text-sm"
        >
          Seleccione una unidad funcional válida
        </div>
      </div>

      <!-- Campo: Área -->
      <div *ngIf="showArea">
        <label for="id_area" class="block text font-semibold">Área</label>
        <select
          id="id_area"
          formControlName="id_area"
          class="mt-1 block w-full border rounded p-2"
          [class.border-red-500]="
            especialistaForm.get('id_area')?.invalid &&
            especialistaForm.get('id_area')?.touched
          "
        >
          <option [value]="null" disabled selected hidden>
            Seleccione un área
          </option>
          <option *ngFor="let area of areas" [value]="area.id_area">
            {{ area.nombre }}
          </option>
        </select>
        <div
          *ngIf="
            especialistaForm.get('id_area')?.invalid &&
            especialistaForm.get('id_area')?.touched
          "
          class="text-red-500 text-sm"
        >
          Seleccione un área válida
        </div>
      </div>
    </div>
    <div class="flex justify-end mt-6">
      <div>
        <button
          type="submit"
          class="bg-blue-500 text-white font-semibold px-6 py-2 rounded-lg shadow hover:bg-blue-600"
        >
          Guardar
        </button>
      </div>
    </div>
  </form>
</div>
